var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 70"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 61",
    x: 26.1131,
    y: 0.863525,
    width: 7.67735,
    height: 7.67734,
    rx: 1.09676,
    transform: "rotate(25.4195 26.1131 0.863525)",
    fill: "#FFA692"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 46",
    cx: 17.3339,
    cy: 8.13372,
    rx: 5.48382,
    ry: 5.48382,
    fill: "#FFA692"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 60",
    d: "M7.46297 7.20557H33.2215C34.6321 7.20557 35.676 8.51783 35.3588 9.89233L33.0809 19.7632C32.8512 20.7585 31.965 21.4635 30.9436 21.4635H10.7533L7.46297 7.20557Z",
    fill: "#EFF4F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M32.6683 25.0645H14.4286C12.905 25.0645 11.5807 24.0185 11.2278 22.5363L6.34593 2.03247H1.95888",
    stroke: "#8BA293",
    strokeWidth: 2.19353,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 44",
    cx: 15.12,
    cy: 27.8066,
    rx: 2.19353,
    ry: 2.19353,
    fill: "#8BA293"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 45",
    cx: 28.2811,
    cy: 27.8066,
    rx: 2.19353,
    ry: 2.19353,
    fill: "#8BA293"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoping);
export default __webpack_public_path__ + "static/media/shoping.ef82e660fe7ba726f10d31e833b0655b.svg";
export { ForwardRef as ReactComponent };